export default "__VITE_ASSET__BCFKAO4E__"